/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
/* eslint-disable */
import { FormEditCreateUpdateProcessOrderStockOuttakeFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/process-order-stock-outtake/create-update/form-edit-create-update-process-order-stock-outtake-field-dialog.component';
/* eslint-enable */

/* eslint-enable */

export class FormEditProcessOrderStockOuttakeFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateProcessOrderStockOuttakeFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateProcessOrderStockOuttakeFieldDialogComponent)
      .create(this.injector);
  }

}
